export default __webpack_public_path__ + "static/media/languageDU.44a25a63.png";